﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconBuildingStadium } from "@tabler/icons-react";

export const AreasPersonalHelpText = '* Aquí puede ver la lista de las areas del personal.';
export const AreasPersonalIcon = IconBuildingStadium;

export class catAreasPersonal extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "AreasPersonal";
        this.def.columns.c_category_id.defaultValue = "AreasPersonal";
        this.Title = "Áreas de Personal";
        this.HelpText = AreasPersonalHelpText;
        this.Icon = AreasPersonalIcon;
    }
}